import type { StoredState } from '../types/chat'

export function loadState(key: string): StoredState | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as StoredState
  } catch {
    return null
  }
}

export function saveState(key: string, state: StoredState): void {
  try {
    localStorage.setItem(key, JSON.stringify(state))
  } catch {
    // ignore quota errors
  }
}

export function generateSessionId(): string {
  return 'bc_' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}

interface ConsentRecord {
  granted: boolean
  at: number
  version: string | null
}

/**
 * Returns true only if a matching, still-valid consent was previously stored.
 * If `version` is given, a stored consent with a different version is treated
 * as not granted (so a policy change re-triggers the gate).
 */
export function loadConsent(key: string, version?: string): boolean {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return false
    const parsed = JSON.parse(raw) as Partial<ConsentRecord>
    if (!parsed?.granted) return false
    if (version && parsed.version !== version) return false
    return true
  } catch {
    return false
  }
}

export function saveConsent(key: string, version?: string): void {
  try {
    const record: ConsentRecord = { granted: true, at: Date.now(), version: version ?? null }
    localStorage.setItem(key, JSON.stringify(record))
  } catch {
    // ignore quota errors
  }
}

export function clearConsent(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
